module.exports = __webpack_public_path__ + "media/assets/systems-map-icons/ManageBacTitle-fcee71fa8f293faf31e6602d65b7a0fe4b1d28311958a9742b9134bec3cbc17d.png";